import {NgxFilterBaseComponent} from "../ngx-filter-base-component";

export abstract class NgxDateFilter extends NgxFilterBaseComponent {

}
